<template>
  <div class="d-flex flex-column">
    <div class="d-flex">
      <v-btn
        color="indigo darken-4"
        class="white--text"
        :disabled="disabledButtonEvent"
        depressed
        @click="createTask(taskTypes.EVENT)"
      >
        {{ $t('PLANNINGS.ADD_EVENT') }}
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn
        color="red darken-4"
        class="white--text"
        :disabled="disabledButtonBlockDay"
        depressed
        @click="createTask(taskTypes.BLOCK_DAY)"
      >
        {{ $t('PLANNINGS.BLOCK_DAY') }}
      </v-btn>
    </div>
    <v-card class="my-4 flex-grow-1">
      <v-card-text v-if="selectedDay && selectedEntity" class="fill-height">
        <employee-tasks-list
          :day="selectedDay.date"
          :tasks="SELECTED_DAY_TASKS"
          :employee="selectedEntity"
          @view="viewTask"
        ></employee-tasks-list>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" persistent max-width="1400px">
      <template v-if="action">
        <component
          :is="component"
          :id="taskId"
          :key="taskId"
          :task-to-copy="taskToCopy"
          @created="cancelDialog"
          @updated="cancelDialog"
          @removed="cancelDialog"
          @cancel="cancelDialog"
        ></component>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import EmployeeTasksList from '../components/EmployeeTasksList';
import taskTypes from '../common/types';
import { DAY_OFF, VOCATION, SICK_LEAVE } from '../common/reasons';
import moment from 'moment';

export default {
  name: 'Tasks',

  components: {
    EmployeeTasksList,
    CreateBlockDayTask: () => import('./BlockDay/CreateBlockDayTask'),
    ViewBlockDayTask: () => import('./BlockDay/ViewBlockDayTask'),
    CreateEventTask: () => import('./Event/CreateEventTask'),
    ViewEventTask: () => import('./Event/ViewEventTask')
  },

  data: () => ({
    dialog: false,
    action: null,
    taskId: null,
    taskToCopy: null,
    componentType: null,
    taskTypes
  }),

  computed: {
    ...mapState('planning', [
      'selectedDay',
      'selectedEntity',
      'employeesRequestedVacations'
    ]),
    ...mapGetters('planning', ['SELECTED_DAY_TASKS', 'SELECTED_ORDER']),

    component() {
      return `${this.action}-${this.componentType}-task`;
    },

    existAllBlockDayTaskInSelectedDay() {
      return this.SELECTED_DAY_TASKS.some(({ type, reason }) => {
        return (
          reason &&
          type === this.taskTypes.BLOCK_DAY &&
          [DAY_OFF, VOCATION, SICK_LEAVE].includes(reason.id)
        );
      });
    },

    disabledButtonBlockDay() {
      return Boolean(
        !this.selectedDay ||
          !this.selectedEntity ||
          this.existAllBlockDayTaskInSelectedDay
      );
    },

    disabledButtonEvent() {
      return Boolean(
        !this.selectedDay ||
          !this.selectedEntity ||
          !this.SELECTED_ORDER ||
          this.existAllBlockDayTaskInSelectedDay ||
          this.isDayVacationRequest
      );
    },

    isDayVacationRequest() {
      if (this.employeesRequestedVacations.length === 0) {
        return false;
      }

      let approvedVacations = this.employeesRequestedVacations.filter(
        vacation => vacation.status.id === 'approved'
      );

      return approvedVacations.some(
        item =>
          item.employee_id === this.selectedEntity.id &&
          moment(this.selectedDay.date, 'YYYY-MM-DD').isBetween(
            item.date_from,
            item.date_to,
            undefined,
            '[]'
          )
      );
    }
  },

  methods: {
    ...mapActions('planning', ['setDay', 'getOrdersList']),

    cancelDialog() {
      this.dialog = false;
      this.action = null;
      this.taskId = null;
      this.taskToCopy = null;
      this.componentType = null;
    },
    showDialog() {
      this.dialog = true;
    },
    createTask(type) {
      this.action = 'create';
      this.componentType = this.getComponentTypeByTask(type);
      this.showDialog();
    },
    copyTask({ event, day, entity }) {
      this.action = 'create';
      this.componentType = this.getComponentTypeByTask(event.input.type);
      const excludedFields = new Set(['id', 'employee', 'employee_id']);

      let taskData = Object.fromEntries(
        Object.entries(event.input).filter(([key]) => !excludedFields.has(key))
      );
      this.taskToCopy = {
        ...taskData,
        start_date: day.date,
        date_from: day.date,
        end_date: moment(event.end_date, 'YYYY-MM-DD').isBefore(day.date)
          ? day.date
          : event.end_date
      };
      this.showDialog();
    },
    viewTask(task) {
      this.action = 'view';
      this.componentType = this.getComponentTypeByTask(task.type);
      this.taskId = task.id;
      this.showDialog();
    },
    getComponentTypeByTask(type) {
      switch (type) {
        case taskTypes.EVENT:
          return 'event';
        case taskTypes.BLOCK_DAY:
          return 'block-day';
        default:
          throw new Error('Undefined task type!');
      }
    }
  }
};
</script>

<style scoped></style>
